/* TPW PRODUCT CARD v3 — hover-crossfade + quick-add engine (MVP, 2026-06-20).
   The in-card multi-image SCROLL gallery (arrows / counter / swipe / wheel
   axis-routing) was removed for MVP — backed up in
   _card-gallery-scroll-backup/. The card now shows the main image and
   cross-fades to a SECOND image on hover (desktop pointer only). One delegated
   engine for every card surface, including cards that arrive later via AJAX
   (predictive search, recommendations, load-more):
   - the hover image is DEFERRED (loads on first hover/focus, never on touch)
   - clicks: capture-phase delegation on document (never triggers the card link)
   - add to cart: /cart/add.js + cart-icon-bubble section re-render */
(function () {
  "use strict";
  if (window.__tpwCardV3) return;
  window.__tpwCardV3 = true;

  /* ---- image reveal + transition arming ----------------------------------
     1) Reveal each card image with an opacity fade (CSS .is-imgloaded),
        robust to already-cached/complete images + load event + a failsafe.
     2) ARM the fade transitions only AFTER first paint is done, by adding
        <html>.tpwc-armed, so nothing animates on initial load. */
  function revealImg(img) {
    if (!img || img.__tpwcRevealed) return;
    /* NEVER reveal an un-hydrated DEFERRED (hover) image: its src is still the
       transparent 1×1 placeholder, so .is-imgloaded would paint a grey box.
       The deferred hover image is revealed by hydrate() once it has a real src. */
    if (img.hasAttribute("data-tpwc-src")) return;
    /* V71: a scrub frame built by buildFrames() has no src until its zone asks for it; never reveal it empty
       (a revealed frame paints the media plate, which would cover the main image as a grey box). */
    if (!img.getAttribute("src")) return;
    img.__tpwcRevealed = true;
    img.classList.add("is-imgloaded");
  }
  function wireImg(img) {
    if (img.__tpwcWired) return;
    /* the deferred hover image carries only a 1×1 placeholder until first hover;
       don't reveal/wire it now (it's already "complete") — hydrate() handles it. */
    if (img.hasAttribute("data-tpwc-src")) return;
    img.__tpwcWired = true;
    if (img.complete && img.naturalWidth > 0) { revealImg(img); return; }
    img.addEventListener("load", function () { revealImg(img); }, { once: true });
    img.addEventListener("error", function () { revealImg(img); }, { once: true });
  }
  function scanImgs(root) {
    (root || document).querySelectorAll("img.tpwc__img").forEach(wireImg);
  }

  /* ---- deferred scrub frames (V71 21 Oct, Flash ranks 1 + 3) --------------
     Frames 2..N are not in the HTML: the status gauge carries their 720px URLs
     (data-tpwc-frames, "|" separated) and data-tpwc-sizes. buildFrames() makes
     the <img> nodes (no src) on the first real hover; loadFrame() fetches ONE
     frame (fetchpriority low, srcset rebuilt from the URL) only when the cursor
     reaches its zone or the zone before it. Touch never builds or loads them. */
  var FRAME_W = [360, 540, 720, 900, 1080];
  function frameSrcset(u) {
    return FRAME_W.map(function (w) { return u.replace(/([?&])width=\d+/, "$1width=" + w) + " " + w + "w"; }).join(", ");
  }
  function buildFrames(media) {
    if (media.__tpwcFrames) return media.__tpwcFrames;
    var bar = media.querySelector("[data-tpwc-frames]");
    var list = bar ? (bar.getAttribute("data-tpwc-frames") || "").split("|").filter(Boolean) : [];
    var sizes = bar ? bar.getAttribute("data-tpwc-sizes") : "";
    var out = [];
    list.forEach(function (u, k) {
      var img = document.createElement("img");
      img.className = "tpwc__img tpwc__img--frame";
      img.setAttribute("data-frame", String(k + 1));
      img.setAttribute("alt", "");
      img.setAttribute("aria-hidden", "true");
      img.setAttribute("decoding", "async");
      img.__tpwcWired = true; /* the MutationObserver must not wire a node without a src */
      img.__tpwcUrl = u;
      img.__tpwcSizes = sizes;
      media.insertBefore(img, bar);
      out.push(img);
    });
    media.__tpwcFrames = out;
    return out;
  }
  function loadFrame(img) {
    if (!img || img.__tpwcLoading) return;
    img.__tpwcLoading = true;
    img.addEventListener("load", function () { revealImg(img); }, { once: true });
    img.addEventListener("error", function () { revealImg(img); }, { once: true });
    img.setAttribute("fetchpriority", "low");
    if (img.__tpwcSizes) img.setAttribute("sizes", img.__tpwcSizes);
    img.setAttribute("srcset", frameSrcset(img.__tpwcUrl));
    img.setAttribute("src", img.__tpwcUrl);
  }

  function armCards() {
    var html = document.documentElement;
    scanImgs(document);
    /* arm the fade transitions on the next frame so the first paint is static.
       rAF can be throttled to never-fire in background tabs (documented QA
       lesson), so a setTimeout failsafe guarantees the armed state lands. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { html.classList.add("tpwc-armed"); });
    });
    setTimeout(function () { html.classList.add("tpwc-armed"); }, 200);
    /* failsafe: never leave a MAIN image stuck invisible (deferred hover images
       are skipped by revealImg until hydrated). */
    setTimeout(function () {
      document.querySelectorAll("img.tpwc__img:not(.is-imgloaded)").forEach(revealImg);
    }, 2500);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", armCards, { once: true });
  } else {
    armCards();
  }

  /* cards arriving later (AJAX search / recs / load-more): wire their imgs.
     The page is already armed, so they fade in cleanly as they load. */
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches("img.tpwc__img")) wireImg(n);
        else if (n.querySelectorAll) scanImgs(n);
      }
    }
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  else document.addEventListener("DOMContentLoaded", function () {
    mo.observe(document.body, { childList: true, subtree: true });
  }, { once: true });

  /* Section ids we need refreshed after a card add: the header bubble (count +
     total, which then ROLL via tpw-cart-roll.js) AND the drawer contents, so the
     drawer is CURRENT the instant a shopper opens it (founder bug 2026-06-26 —
     card adds previously left the drawer stale until a slow interceptor caught
     up). We request these in the SAME /cart/add.js call (one round-trip). */
  var CARD_SECTION_IDS = "cart-icon-bubble,cart-drawer";

  /* Swap the header bubble + drawer inner from a sections payload (from the add
     response, or a standalone ?sections= fetch as fallback). */
  function applyCartSections(sections) {
    if (!sections) return;
    if (sections["cart-icon-bubble"]) {
      var bHolder = document.createElement("div");
      bHolder.innerHTML = sections["cart-icon-bubble"];
      var freshBubble = bHolder.querySelector("#cart-icon-bubble") ||
        bHolder.querySelector(".shopify-section") || bHolder.firstElementChild;
      document.querySelectorAll("#cart-icon-bubble").forEach(function (el) {
        if (freshBubble) el.innerHTML = freshBubble.innerHTML;
      });
    }
    if (sections["cart-drawer"]) {
      var dHolder = document.createElement("div");
      dHolder.innerHTML = sections["cart-drawer"];
      var freshDrawer = dHolder.querySelector("#CartDrawer");
      var cartDrawer = document.querySelector("cart-drawer");
      var liveDrawer = cartDrawer && cartDrawer.querySelector("#CartDrawer");
      if (freshDrawer && liveDrawer) {
        liveDrawer.innerHTML = freshDrawer.innerHTML;
        cartDrawer.classList.remove("is-empty");
        var inner = cartDrawer.querySelector(".cart-drawer__inner");
        var cdi = cartDrawer.querySelector("cart-drawer-items");
        if (inner) inner.classList.remove("is-empty");
        if (cdi) cdi.classList.remove("is-empty");
        var overlay = cartDrawer.querySelector("#CartDrawer-Overlay");
        if (overlay) overlay.addEventListener("click", function () { cartDrawer.close(); });
      }
    }
  }

  /* Fallback: standalone section fetch (used only if the add response carried no
     sections, e.g. an older add path). */
  function refreshCartBubble() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    fetch(root + "?sections=" + CARD_SECTION_IDS, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(applyCartSections)
      .catch(function () {});
  }

  /* crisp straight-stroke tick (square caps + miter) — not a curvy glyph */
  var CHECK_SVG = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M3.5 8.4L6.7 11.4L12.5 4.8" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="square" stroke-linejoin="miter"/></svg>';

  /* product type -> personal "[thing] is yours!" success line. Read off the
     card root's data-tpw-type; safe default inside ownLine(). */
  function cardType(el) {
    var card = el && el.closest ? el.closest("[data-tpw-type]") : null;
    return card ? (card.getAttribute("data-tpw-type") || "") : "";
  }
  function ownLine(el) {
    return (window.TPWLoading && TPWLoading.ownLine)
      ? TPWLoading.ownLine(cardType(el)) : "Added";
  }

  /* Orion pass 2 (Argus S-14): quick add respects the stock ceiling exactly like the PDP. The PDP refuses because
     Shopify answers 422 past stock; quick add never read that answer (any !ok became a silent reset) and never
     checked the line already in the cart, so a second "Last one" unit could go in. Now: (1) when the card carries
     data-tpwc-max (Shopify-tracked, deny policy) the cart's own line quantity is read first and the add is refused
     at the ceiling without posting; (2) a 422 from /cart/add.js is surfaced; (3) every refusal is shown as one
     line of text on the card (role=status, so it is announced) and cleared on the next attempt or success. */
  var TPWC_MAX_MSG = "The maximum quantity of this item is already in your cart.";
  var TPWC_FAIL_MSG = "Sorry, this could not be added to your cart.";
  function tpwcCartQty(vid) {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var q = 0;
        (c && c.items || []).forEach(function (it) { if (String(it.variant_id || it.id) === String(vid)) q += it.quantity || 0; });
        return q;
      });
  }
  function tpwcUnderCap(el) {
    var max = parseInt(el.getAttribute("data-tpwc-max"), 10);
    if (!isFinite(max)) return Promise.resolve(true);
    if (max <= 0) return Promise.resolve(false);
    return tpwcCartQty(el.getAttribute("data-tpwc-vid"))
      .then(function (q) { return q < max; })
      .catch(function () { return true; }); /* the server still refuses past stock; the 422 path below shows it */
  }
  function tpwcPost(vid, el) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1, sections: CARD_SECTION_IDS, sections_url: location.pathname }),
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (res) {
        if (!r.ok) throw new Error((res && res.description) || TPWC_FAIL_MSG);
        try { var sh = el && el.closest && el.closest("[data-tps-src]"); document.dispatchEvent(new CustomEvent("tps:src", { detail: sh ? sh.getAttribute("data-tps-src") : "other" })); } catch (e) {} // EXP-0002 stamp, assets/tps-src.js (a strip may name itself via data-tps-src; unknown words collapse to other)
        return res;
      });
    });
  }
  function tpwcAdd(el) {
    return tpwcUnderCap(el).then(function (ok) {
      if (!ok) throw new Error(TPWC_MAX_MSG);
      return tpwcPost(el.getAttribute("data-tpwc-vid"), el);
    });
  }
  function tpwcMsg(el, msg) {
    var card = el && el.closest ? el.closest(".tpwc") : null;
    if (!card) return;
    var p = card.querySelector("[data-tpwc-msg]");
    if (!msg) { if (p) { p.textContent = ""; p.hidden = true; } return; }
    if (!p) {
      p = document.createElement("p");
      p.className = "tpwc__msg";
      p.setAttribute("data-tpwc-msg", "");
      p.setAttribute("role", "status");
      card.appendChild(p);
    }
    p.hidden = false;
    p.textContent = "";
    /* empty first, text a tick later, so a freshly inserted status region is announced */
    setTimeout(function () { p.textContent = msg; }, 60);
  }
  function tpwcErrText(err) {
    return (err && err.message && err.message !== "add failed") ? err.message : TPWC_FAIL_MSG;
  }

  function add(btn) {
    if (btn.__busy) return;
    var vid = btn.getAttribute("data-tpwc-vid");
    if (!vid) return;
    btn.__busy = true;
    /* the glass + button swaps its icon to a tick; the hover bar swaps text.
       P1 "the Beam": both now run the shared working->done language via
       window.TPWLoading — the round + sweeps an ARC beam (shape:circle), the
       wide hover bar fills a hairline (shape:wide). Both contrast their dark
       surface with a WHITE beam. Guarded: fall back to the old instant tick. */
    var isPlus = btn.classList.contains("tpwc__plus");
    var savedHTML = btn.innerHTML;
    var label = btn.textContent;
    var TL = window.TPWLoading;

    if (TL) {
      if (isPlus) {
        // arc-beam working state: hide the static + glyph while the ring sweeps.
        // The glass surface is LIGHT, so the working ring is an INK beam; on done
        // the button flips to its ink .is-added bg with a WHITE centre tick.
        btn.dataset.tpwcIcon = savedHTML;
        btn.innerHTML = "";
        TL.start(btn, { shape: "circle", onColor: "light" });
      } else {
        TL.start(btn, { shape: "wide", onColor: "dark", label: "Adding" });
      }
    } else {
      // legacy fallback: no in-flight (jumps straight to done on resolve)
    }

    // claim this add so the global cart refresher skips its redundant fetch
    window.__tpwCartHandled = Date.now();
    tpwcMsg(btn, "");
    tpwcAdd(btn)
      .then(function (res) {
        window.__tpwCartHandled = Date.now();
        // /cart/add.js sections are unreliable on this theme — always pull from
        // the dedicated ?sections= endpoint so the header count + drawer never go
        // stale (matches the pdpv9 guaranteed-refresh fix, founder 2026-06-26).
        refreshCartBubble();
        if (TL) {
          if (isPlus) {
            // the round + : flip to the ink .is-added bg + draw a WHITE centre tick
            btn.classList.add("is-added");
            btn.style.setProperty("--tpwl-beam", "#FFFFFF");
            TL.done(btn, { hold: 1600, idleLabel: "" });
            setTimeout(function () {
              btn.classList.remove("is-added");
              btn.style.removeProperty("--tpwl-beam");
              btn.innerHTML = btn.dataset.tpwcIcon || savedHTML;
              delete btn.dataset.tpwcIcon;
              btn.__busy = false;
            }, 1600);
          } else {
            TL.done(btn, { tick: false, label: ownLine(btn), hold: 1600, idleLabel: label });
            setTimeout(function () { btn.__busy = false; }, 1600);
          }
        } else {
          btn.classList.add("is-added");
          if (isPlus) { btn.innerHTML = CHECK_SVG; } else { btn.textContent = ownLine(btn); }
          setTimeout(function () {
            btn.classList.remove("is-added");
            if (isPlus) { btn.innerHTML = savedHTML; } else { btn.textContent = label; }
            btn.__busy = false;
          }, 1600);
        }
      })
      .catch(function (err) {
        if (TL) {
          TL.reset(btn);
          if (isPlus) { btn.innerHTML = btn.dataset.tpwcIcon || savedHTML; delete btn.dataset.tpwcIcon; }
          else { btn.textContent = label; }
        } else {
          if (isPlus) { btn.innerHTML = savedHTML; } else { btn.textContent = label; }
        }
        btn.__busy = false;
        tpwcMsg(btn, tpwcErrText(err));
      });
  }

  document.addEventListener(
    "click",
    function (e) {
      if (!e.target.closest) return;
      var addBtn = e.target.closest("[data-tpwc-add]");
      if (addBtn) { e.preventDefault(); e.stopPropagation(); add(addBtn); return; }
      var choose = e.target.closest("[data-tpwc-choose]");
      if (choose) {
        e.preventDefault(); e.stopPropagation();
        /* TPS v6 batch F (T-15): the options ledger now lives in .tpwc__acts, a sibling of the card link */
        var media = choose.closest(".tpwc__acts") || choose.closest(".tpwc__media");
        var panel = media && media.querySelector("[data-tpwc-opts]");
        if (panel) panel.classList.add("is-open");
        return;
      }
      var closeBtn = e.target.closest("[data-tpwc-optclose]");
      if (closeBtn) {
        e.preventDefault(); e.stopPropagation();
        closeBtn.closest("[data-tpwc-opts]").classList.remove("is-open");
        return;
      }
      var opt = e.target.closest("[data-tpwc-optadd]");
      if (opt) {
        e.preventDefault(); e.stopPropagation();
        if (opt.disabled || opt.__busy) return;
        opt.__busy = true;
        var nm = opt.querySelector(".tpwc__opt-nm");
        var label = nm ? nm.textContent : "";
        var TLo = window.TPWLoading;
        // P1 beam on the ledger row: ink beam working on the white row; on done
        // the row flips to its ink .is-added bg (text -> white via CSS).
        if (TLo) { TLo.start(opt, { shape: "wide", onColor: "light", labelEl: nm, label: "Adding" }); }
        window.__tpwCartHandled = Date.now();
        tpwcMsg(opt, "");
        tpwcAdd(opt)
          .then(function (res) {
            window.__tpwCartHandled = Date.now();
            refreshCartBubble(); // always reliable refresh (add-response sections unreliable)
            opt.classList.add("is-added");
            if (TLo) {
              // white tick on the ink bg
              opt.style.setProperty("--tpwl-beam", "#FFFFFF");
              TLo.done(opt, { tick: false, label: ownLine(opt), labelEl: nm, hold: 900, idleLabel: label });
              setTimeout(function () {
                opt.classList.remove("is-added");
                opt.style.removeProperty("--tpwl-beam");
                opt.__busy = false;
                var panel = opt.closest("[data-tpwc-opts]");
                if (panel) panel.classList.remove("is-open");
              }, 900);
            } else {
              if (nm) nm.textContent = ownLine(opt);
              setTimeout(function () {
                opt.classList.remove("is-added");
                if (nm) nm.textContent = label;
                opt.__busy = false;
                var panel = opt.closest("[data-tpwc-opts]");
                if (panel) panel.classList.remove("is-open");
              }, 900);
            }
          })
          .catch(function (err) {
            if (TLo) { TLo.reset(opt, label); opt.classList.remove("is-added"); opt.style.removeProperty("--tpwl-beam"); }
            opt.__busy = false;
            tpwcMsg(opt, tpwcErrText(err));
          });
        return;
      }
      /* clicks anywhere else inside an OPEN options panel must not follow the card link */
      var insidePanel = e.target.closest("[data-tpwc-opts]");
      if (insidePanel) { e.preventDefault(); e.stopPropagation(); }
    },
    true
  );

  /* ---- cursor-scrub (desktop only) -----------------------------------------
     Moving the cursor across a card's image steps through that product's extra
     images (2..N), chosen by horizontal cursor position; the segmented gauge
     follows. Armed after a 120 ms dwell on the card (a fly-by costs nothing);
     each zone fetches its own frame and the next one, so a casual hover pays
     for one or two frames, not all four. Gated to fine pointers: touch never
     builds or loads frames. */
  var SCRUB_OK = null;
  function scrubOk() {
    if (SCRUB_OK === null) SCRUB_OK = !!(window.matchMedia && window.matchMedia("(hover:hover) and (pointer:fine)").matches);
    return SCRUB_OK;
  }
  function setupScrub(media) {
    if (!media || media.__tpwScrub || !scrubOk()) return null;
    if (!media.querySelector("[data-tpwc-frames]")) return null;
    var frames = buildFrames(media);
    if (!frames.length) return null;
    var segs = media.querySelectorAll(".tpwc__seg");
    var N = frames.length + 1, rect = null, cur = -1;
    function measure() { rect = media.getBoundingClientRect(); }
    function want(i) { /* zone i shows frames[i - 1]; warm the zone ahead (frames[i]) */
      if (i >= 1) loadFrame(frames[i - 1]);
      if (i < frames.length) loadFrame(frames[i]);
    }
    function setZone(i) {
      want(i);
      if (i === cur) return;
      cur = i;
      var oi = i - 1; /* -1 = main image (no overlay) */
      for (var k = 0; k < frames.length; k++) frames[k].classList.toggle("is-on", k === oi);
      for (var s = 0; s < segs.length; s++) segs[s].classList.toggle("is-active", s === i);
    }
    function zoneAt(x) {
      if (!rect) measure();
      var i = Math.floor(((x - rect.left) / rect.width) * N);
      return i < 0 ? 0 : (i > N - 1 ? N - 1 : i);
    }
    media.addEventListener("mouseenter", measure);
    media.addEventListener("mousemove", function (e) { setZone(zoneAt(e.clientX)); });
    media.addEventListener("mouseleave", function () { rect = null; setZone(0); });
    media.__tpwScrub = { zoneAt: zoneAt, setZone: setZone };
    return media.__tpwScrub;
  }
  /* V71 21 Oct (speed budget): only pointerenter (120 ms dwell) and focusin arm a card. pointerenter does not bubble,
     but a CAPTURE listener on document still receives it for every element. */
  var lastX = 0;
  document.addEventListener("pointermove", function (e) { lastX = e.clientX; }, { capture: true, passive: true });
  document.addEventListener("pointerenter", function (e) {
    var host = e.target;
    if (!host || !host.classList || !host.classList.contains("tpwc-host") || !scrubOk()) return;
    clearTimeout(host.__tpwcT);
    host.__tpwcT = setTimeout(function () {
      if (!host.matches(":hover")) return;
      var media = host.querySelector(".tpwc__media");
      var sc = setupScrub(media) || (media && media.__tpwScrub);
      if (sc && media.matches(":hover")) sc.setZone(sc.zoneAt(lastX));
      else if (sc) sc.setZone(0);
    }, 120);
  }, { capture: true, passive: true });
  document.addEventListener("pointerleave", function (e) {
    var host = e.target;
    if (host && host.classList && host.classList.contains("tpwc-host")) clearTimeout(host.__tpwcT);
  }, { capture: true, passive: true });
  /* keyboard: focus builds the frame nodes (no fetch, no scrub without a pointer) so a later hover is instant */
  document.addEventListener("focusin", function (e) {
    if (!scrubOk() || !e.target.closest) return;
    var host = e.target.closest(".tpwc-host");
    if (host) setupScrub(host.querySelector(".tpwc__media"));
  }, { capture: true });
})();
